module.exports = __webpack_public_path__ + "static/media/purewatt-gb-5.bf0ba8c8.jpg";